<template>
  <div :class="$style.avatarWrapper">
    <BaseAvatar
      :url="url"
      :size="125"
      :max-width-view-width="25"
    />
    <div
      :class="[
        $style.avatarEdit,
        $style[`avatarEditTheme${theme}`]
      ]"
      @click="$emit('click')"
    >
      <font-awesome-icon icon="pencil-alt" />
    </div>
  </div>
</template>

<script>
import BaseAvatar from '@/components/Atoms/BaseAvatar'
export default {
  name: 'TheChangeAvatar',
  components: { BaseAvatar },
  props: {
    url: {
      type: String,
      default: null,
      required: true,
    },
    theme: {
      type: String,
      default: 'Dark',
      required: false,
    },
  },
}
</script>

<style module lang="scss">
  @import "../../assets/scss/variables";
  .avatarWrapper {
    position: relative;
    width: 125px;
    max-width: 25vw;
    max-height: calc(25vw + 10px);
    .avatarEdit {
      cursor: pointer;
      transition: all .3s ease-in-out;
      position: absolute;
      top: 0;
      right: 0;
      height: 36px;
      width: 36px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      &.avatarEditThemeDark {
        background: $color-midnight-blue;
        border: 1px solid $color-white;
        &:hover {
          background: $color-white;
          color: $color-midnight-blue;
        }
      }
      &.avatarEditThemeLight {
        background: $color-white;
        border: 1px solid $color-midnight-blue;
        &:hover {
          background: $color-midnight-blue;
          color: $color-white;
        }
      }
    }
  }
</style>
